export default __webpack_public_path__ + "static/media/StarRatingBanner.cedcdce9.jpg";